import { parasutApi, errMsg } from "../../lib/parasutApi";
import { formFromPrefill, toPayload } from "./invoiceDefaults";
import { hasNegative } from "./InvoiceLines";

const ACTIVE = ["creating", "processing", "approved"];

// Tek rezervasyonu kurala göre hazırlayıp resmi olarak keser; atlanırsa sebebini döner.
export async function autoInvoice(bookingId) {
  const p = await parasutApi.prefill(bookingId);
  if ((p.invoices || []).some((i) => ACTIVE.includes(i.status))) return { status: "skip", reason: "Zaten faturalı" };
  if (!p.amount) return { status: "skip", reason: "Tutar yok" };
  if (p.country_info?.warning) return { status: "skip", reason: `Ülke kontrol: ${p.country_info.source}` };
  const form = formFromPrefill(p);
  if (hasNegative(form)) return { status: "skip", reason: "Eksi kalan tutar" };
  if (form.currency !== "TRL" && !form.exchange_rate) return { status: "skip", reason: "Kur yok" };
  if (!form.customer_name.trim()) return { status: "skip", reason: "Müşteri adı yok" };
  try {
    const inv = await parasutApi.create(toPayload(form, true));
    return { status: inv.status === "error" ? "error" : "ok", reason: inv.error || "Gönderildi", invoice: inv };
  } catch (e) {
    return { status: "error", reason: errMsg(e) };
  }
}

export async function runBulk(ids, onProgress) {
  const results = {};
  for (const id of ids) {
    onProgress({ id, status: "running" });
    let r;
    try { r = await autoInvoice(id); } catch (e) { r = { status: "error", reason: errMsg(e) }; }
    results[id] = r;
    onProgress({ id, ...r });
  }
  return results;
}
